import styled from '@emotion/styled';

import Button from 'components/field/Button';
import Modal from 'components/global/Modal';
import { ModalContent } from 'components/global/styled/Modal.styled';

import { Breakpoints } from 'utils/const.styles';

export const ModalWrapper = styled(Modal)`
	padding: 0 !important;
	> div {
		padding: 0 !important;
	}
`;

export const ModalContentVariation = styled(ModalContent)`
	height: 100%;
	position: relative;
`;
export const ModalHeader = styled.div`
	position: absolute;
	top: 2rem;
	left: 3rem;

	body[dir='rtl'] & {
		left: unset;
		right: 3rem;
	}
`;

export const TopButtons = styled.div`
	position: absolute;
	top: 1rem;
	right: 6rem;
	z-index: 1;
	display: flex;
	gap: 1rem;

	body[dir='rtl'] & {
		right: unset;
		left: 6rem;
	}

	@media ${Breakpoints.mobile} {
		right: 4rem;

		body[dir='rtl'] & {
			right: unset;
			left: 4rem;
		}
	}
`;

const commonSearchInputStyles = `
	border-radius: 400px;
	height: 6rem;
	max-height: 20rem;
	padding: 2rem 6rem 2rem 2rem;
	box-shadow: 0px 4px 10px var(--container-box-shadow);
	resize: none;
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none; /* For Firefox */
	-ms-overflow-style: none; /* For Internet Explorer and Edge */

	&::-webkit-scrollbar {
		display: none; /* For Chrome, Safari, and Opera */
	}

	body[dir='rtl'] & {
		padding: 2rem 2rem 2rem 6rem;
	}
`;

export const EmptyStateSearchInputWrapper = styled.div`
	position: relative;
	width: 100%;
	margin-top: 3rem;

	> .ai-search-input {
		${commonSearchInputStyles}
	}
`;

export const SearchInputWrapper = styled.div`
	width: 90%;
	position: absolute;
	bottom: 2rem;

	> .ai-search-input {
		${commonSearchInputStyles}
	}
`;

export const SearchInputButton = styled(Button)`
	position: absolute;
	right: 1rem;
	top: 50%;
	transform: translateY(-50%);

	body[dir='rtl'] & {
		right: unset;
		left: 1rem;
	}
`;

export const ExamplesWrapper = styled.div`
	margin-top: 3rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
`;

export const PredefinedQuestionBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	cursor: pointer;
	width: ${({ size }) => (size === 'large' ? '100%' : '49%')};
	border: 1px solid var(--border-color);
	padding: 3rem;
	border-radius: 6px;

	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const MessageBubble = styled.div`
	max-width: 60%;
	padding: 1rem 2rem;
	border: 1px solid var(--border-color);
	word-wrap: break-word;
	border-radius: 34.5px 34.5px 0 34.5px;
`;

export const AgentResponse = styled.div`
	max-width: 90%;
	font-size: 1.51rem;
	color: var(--black);

	> pre {
		overflow: auto;
	}

	> code {
		white-space: pre-wrap;
	}
`;

export const CodeBlock = styled.code`
	display: block;
	background-color: var(--code-block-bg);
	border-radius: 8px;
	color: var(--alwaysWhiteColor);
	position: relative;
`;

export const CodeBlockHeader = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	background-color: var(--code-block-header-bg);
	border-radius: 8px 8px 0 0;
	color: var(--alwaysWhiteColor);
	padding: 0rem 1rem;
	& > button > div {
		color: var(--alwaysWhiteColor) !important;
	}
`;

export const CodeBlockContent = styled.div`
	padding: 2rem;
	overflow: scroll;
`;

export const ModalContentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 100%;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const ChatWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: ${({ isHistoryOpen }) => (isHistoryOpen ? '50%' : '100%')};
	height: 100%;
	padding: 7rem 0 10rem 0;
	position: relative;

	&.empty {
		padding: 7rem 0 3rem 0;
	}

	@media ${Breakpoints.mobile} {
		width: 100%;
		max-height: ${({ isHistoryOpen }) => (isHistoryOpen ? '60%' : '100%')};
	}
`;

export const EmptyStateWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	height: 100%;
	overflow-y: scroll;

	> span {
		flex-shrink: 0;
	}

	@media ${Breakpoints.mobile} {
		justify-content: unset;
		gap: 0;
	}
`;

export const TextWrapper = styled.div`
	width: 80%;
	text-align: center;
`;

export const ChatWindow = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	overflow-y: scroll;
`;

export const Message = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 1rem;
	padding: 0 3rem;
	justify-content: ${({ sender }) => (sender === 'User' ? 'flex-end' : 'flex-start')};
`;

export const PredefinedQuestions = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	flex-wrap: wrap;
`;

export const QuestionHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;

export const AgentResponseLoading = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
	padding: 0 3rem;
`;
